import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import "./sidebar.scss";

import { Tooltip } from "@mui/material";
import { COLOR_PALLATE } from "../../pcdoConstants";

const getInitSelectedKey = () => {
  //   localStorage.getItem('selectedSidebarKey') ?? null
  return null
}

function Sidebar({ sidebarRoutes, handleSidebarItemClick, selectedSidebarKey }) {



  const isSelected = (key) => {
    return selectedSidebarKey === key;
  };
  return (
    <div className="sidebar-container layout-comp">
      <div className="sidebar shortSidebar">
        {sidebarRoutes.map((sidebarItemInfo) => {
          const { shortDes, longDes, url, key } = sidebarItemInfo;
          return (
            <Tooltip title={longDes} placement="right">
              <div
                key={key}
                onClick={() => handleSidebarItemClick(key)}
                className={`sidebarItem`}
              >
                <div
                  style={{
                    backgroundColor: isSelected(key)
                      ? COLOR_PALLATE.selectedSidebarColor
                      : "#ffffff"
                  }}
                  className={`itemcode-avatar ${isSelected(key)
                    ? "item-selected"
                    : "not-selected-sidebarItem"
                    }`}
                >
                  {shortDes}
                </div>
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
}

export default Sidebar;
